/*
 Input Mask plugin dependencyLib
 http://github.com/RobinHerbots/jquery.inputmask
 Copyright (c) Robin Herbots
 Licensed under the MIT license
 */

import jQuery from "jquery";

if (jQuery === undefined) {
  throw new Error("jQuery not loaded!");
}
export default jQuery;
